export const PORT = [
  { value: 1, name: '(TCPMUX)' },
  { value: 2, name: 'CompressNET Management Utility' },
  { value: 3, name: 'CompressNET Compression Process' },
  { value: 5, name: 'Remote Job Entry' },
  { value: 7, name: 'Echo Protocol' },
  { value: 9, name: 'Discard Protocol or Wake-on-LAN' },
  { value: 11, name: 'Active Users (systat service)' },
  { value: 13, name: 'Daytime Protocol' },
  { value: 15, name: 'Previously netstat service' },
  { value: 17, name: 'Quote of the Day' },
  { value: 18, name: 'Message Send Protocol' },
  { value: 19, name: 'Character Generator Protocol (CHARGEN)' },
  { value: 20, name: 'FTP data transfer' },
  { value: 21, name: 'FTP control' },
  { value: 22, name: 'Secure Shell (SSH)' },
  { value: 23, name: 'Telnet' },
  { value: 24, name: 'Priv-mail' },
  { value: 25, name: 'Simple Mail Transfer Protocol (SMTP)' },
  { value: 26, name: 'Encrypted SMTP' },
  { value: 27, name: 'NSW User System FE' },
  { value: 29, name: 'MSG ICP' },
  { value: 33, name: 'Display Support Protocol' },
  { value: 35, name: 'Any private printer server protocol' },
  { value: 37, name: 'TIME protocol' },
  { value: 39, name: 'Resource Location Protocol (RLP)' },
  { value: 42, name: 'ARPA Host Name Server Protocol' },
  { value: 42, name: 'Windows Internet Name Service' },
  { value: 43, name: 'WHOIS protocol' },
  { value: 47, name: 'NI FTP' },
  { value: 49, name: 'TACACS Login Host protocol' },
  { value: 50, name: 'Remote Mail Checking Protocol' },
  { value: 51, name: 'IMP Logical Address Maintenance' },
  { value: 52, name: 'XNS Time Protocol' },
  { value: 53, name: 'Domain Name System (DNS)' },
  { value: 54, name: 'XNS Clearinghouse' },
  { value: 55, name: 'ISI Graphics Language (ISI-GL)' },
  { value: 56, name: 'Route Access Protocol (RAP)' },
  { value: 56, name: 'XNS Authentication' },
  { value: 57, name: 'Mail Transfer Protocol' },
  { value: 58, name: 'XNS Mail' },
  { value: 64, name: 'CI (Travelport)' },
  { value: 67, name: 'Bootstrap Protocol (BOOTP) Server' },
  { value: 68, name: 'Bootstrap Protocol (BOOTP) Client' },
  { value: 69, name: 'Trivial File Transfer Protocol (TFTP)' },
  { value: 70, name: 'Gopher protocol' },
  { value: 71, name: 'NETRJS protocol' },
  { value: 72, name: 'NETRJS protocol' },
  { value: 73, name: 'NETRJS protocol' },
  { value: 74, name: 'NETRJS protocol' },
  { value: 77, name: 'Any private Remote Job Entry' },
  { value: 79, name: 'Finger protocol' },
  { value: 80, name: 'Hypertext Transfer Protocol (HTTP)' },
  { value: 81, name: 'Torpark—Onion routing' },
  { value: 82, name: 'Torpark—Control' },
  { value: 88, name: 'Kerberos—authentication system' },
  { value: 90, name: 'dnsix (DoD Network Security for Information Exchange)' },
  { value: 90, name: 'PointCast (dotcom)' },
  { value: 99, name: 'WIP Message protocol' },
  { value: 100, name: 'CyberGate RAT protocol' },
  { value: 101, name: 'NIC host name' },
  { value: 102, name: 'ISO-TSAP (Transport Service Access Point)' },
  { value: 104, name: 'ACR/NEMA Digital Imaging and Communications in Medicine (DICOM)' },
  { value: 105, name: 'CCSO Nameserver Protocol (Qi/Ph)' },
  { value: 107, name: 'Remote TELNET Service protocol' },
  { value: 108, name: 'SNA Gateway Access Server' },
  { value: 109, name: 'Post Office Protocol v2 (POP2)' },
  { value: 110, name: 'Post Office Protocol v3 (POP3)' },
  { value: 111, name: 'ONC RPC (Sun RPC)' },
  { value: 113, name: 'Authentication Service (auth)' },
  { value: 113, name: 'Ident—Authentication Service/Identification Protocol' },
  { value: 115, name: 'Simple File Transfer Protocol (SFTP)' },
  { value: 117, name: 'UUCP Path Service' },
  { value: 118, name: 'SQL (Structured Query Language) Services' },
  { value: 119, name: 'Network News Transfer Protocol (NNTP)' },
  { value: 123, name: 'Network Time Protocol (NTP)' },
  { value: 126, name: 'Unisys / NXEdit' },
  { value: 135, name: 'DCE endpoint resolution' },
  { value: 135, name: 'Microsoft EPMAP (End Point Mapper)' },
  { value: 137, name: 'NetBIOS NetBIOS Name Service' },
  { value: 138, name: 'NetBIOS NetBIOS Datagram Service' },
  { value: 139, name: 'NetBIOS NetBIOS Session Service' },
  { value: 143, name: 'Internet Message Access Protocol (IMAP)' },
  { value: 152, name: 'Background File Transfer Program (BFTP)' },
  { value: 153, name: 'SGMP, Simple Gateway Monitoring Protocol' },
  { value: 156, name: 'SQL Service' },
  { value: 158, name: 'DMSP, Distributed Mail Service Protocol' },
  { value: 161, name: 'Simple Network Management Protocol (SNMP)' },
  { value: 162, name: 'Simple Network Management Protocol Trap (SNMPTRAP)' },
  { value: 170, name: 'Print-srv, Network PostScript' },
  { value: 175, name: 'VMNET (IBM z/VM, z/OS z/VSE - Network Job Entry(NJE))' },
  { value: 177, name: 'X Display Manager Control Protocol (XDMCP)' },
  { value: 179, name: 'BGP (Border Gateway Protocol)' },
  { value: 194, name: 'Internet Relay Chat (IRC)' },
  { value: 199, name: 'SMUX, SNMP Unix Multiplexer' },
  { value: 201, name: 'AppleTalk Routing Maintenance' },
  { value: 209, name: 'The Quick Mail Transfer Protocol' },
  { value: 210, name: 'ANSI Z39.50' },
  { value: 213, name: 'Internetwork Packet Exchange (IPX)' },
  { value: 218, name: 'Message posting protocol (MPP)' },
  { value: 220, name: 'Internet Message Access Protocol (IMAP), version 3' },
  { value: 259, name: 'ESRO, Efficient Short Remote Operations' },
  { value: 264, name: 'BGMP, Border Gateway Multicast Protocol' },
  { value: 280, name: 'http-mgmt' },
  { value: 300, name: 'ThinLinc Web Access' },
  { value: 308, name: 'Novastor Online Backup' },
  { value: 311, name: 'Mac OS X Server Admin' },
  { value: 318, name: 'PKIX TSP, Time Stamp Protocol' },
  { value: 319, name: 'Precision time protocol event messages' },
  { value: 320, name: 'Precision time protocol general messages' },
  { value: 350, name: 'MATIP-Type A' },
  { value: 351, name: 'MATIP-Type B' },
  { value: 366, name: 'ODMR, On-Demand Mail Relay' },
  { value: 369, name: 'Rpc2portmap' },
  { value: 370, name: 'codaauth2' },
  // { value: 370, name: 'codaauth2' },
  { value: 370, name: 'securecast1' },
  { value: 371, name: 'ClearCase albd' },
  { value: 383, name: 'HP data alarm manager' },
  { value: 384, name: 'A Remote Network Server System' },
  { value: 387, name: 'AURP, AppleTalk Update-based Routing Protocol' },
  { value: 389, name: 'Lightweight Directory Access Protocol (LDAP)' },
  { value: 399, name: 'Digital Equipment Corporation DECnet (Phase V+) over TCP/IP' },
  { value: 401, name: 'UPS Uninterruptible Power Supply' },
  { value: 427, name: 'Service Location Protocol (SLP)' },
  { value: 443, name: 'Hypertext Transfer Protocol over TLS/SSL (HTTPS)' },
  { value: 444, name: 'SNPP, Simple Network Paging Protocol' },
  { value: 445, name: 'Microsoft-DS Active Directory, Windows shares' },
  { value: 445, name: 'Microsoft-DS SMB file sharing' },
  { value: 464, name: 'Kerberos Change/Set password' },
  { value: 465, name: 'URL Rendezvous Directory for SSM (Cisco protocol), SMTP over SSL' },
  { value: 475, name: 'tcpnethaspsrv' },
  { value: 491, name: 'GO-Global remote access' },
  { value: 497, name: 'Dantz Retrospect' },
  { value: 500, name: 'Internet Security Association and Key Management Protocol (ISAKMP)' },
  { value: 502, name: 'Modbus, Protocol' },
  { value: 504, name: 'Citadel—multiservice protocol' },
  { value: 512, name: 'comsat / biff' },
  { value: 512, name: 'Rexec, Remote Process Execution' },
  { value: 513, name: 'rlogin' },
  { value: 513, name: 'Who' },
  { value: 514, name: 'Remote Shell (rsh, remsh)' },
  { value: 514, name: 'Syslog—used for system logging' },
  { value: 515, name: 'Line Printer Daemon—print service' },
  { value: 517, name: 'Talk' },
  { value: 518, name: 'NTalk' },
  { value: 520, name: 'efs, extended file name server' },
  { value: 520, name: 'Routing Information Protocol (RIP)' },
  { value: 521, name: 'Routing Information Protocol Next Generation (RIPng)' },
  { value: 524, name: 'NetWare Core Protocol (NCP)' },
  { value: 525, name: 'Timed, Timeserver' },
  { value: 530, name: 'RPC' },
  { value: 531, name: 'AOL Instant Messenger' },
  { value: 532, name: 'netnews' },
  { value: 533, name: 'netwall, For Emergency Broadcasts' },
  { value: 540, name: 'UUCP (Unix-to-Unix Copy Protocol)' },
  { value: 542, name: 'commerce (Commerce Applications)' },
  { value: 543, name: 'klogin, Kerberos login' },
  { value: 544, name: 'kshell, Kerberos Remote shell' },
  { value: 545, name: 'OSIsoft PI (VMS), OSISoft PI Server Client Access' },
  { value: 546, name: 'DHCPv6 client' },
  { value: 547, name: 'DHCPv6 server' },
  { value: 548, name: 'Apple Filing Protocol (AFP) over TCP' },
  { value: 550, name: 'new-rwho, new-who' },
  { value: 554, name: 'Real Time Streaming Protocol (RTSP)' },
  { value: 556, name: 'Remotefs, RFS, rfs_server' },
  { value: 560, name: 'rmonitor, Remote Monitor' },
  { value: 561, name: 'monitor' },
  { value: 563, name: 'NNTP protocol over TLS/SSL (NNTPS)' },
  { value: 587, name: 'email message submission(SMTP)' },
  { value: 591, name: 'FileMaker 6.0+ Web Sharing' },
  { value: 593, name: 'HTTP RPC Ep Map, (Microsoft Exchange)' },
  { value: 604, name: 'TUNNEL' },
  { value: 623, name: 'ASF Remote Management and Control Protocol (ASF-RMCP)' },
  { value: 631, name: 'Common Unix Printing System (CUPS)' },
  { value: 631, name: 'Internet Printing Protocol (IPP)' },
  { value: 635, name: 'RLZ DBase' },
  { value: 636, name: 'Lightweight Directory Access Protocol over TLS/SSL (LDAPS)' },
  { value: 639, name: 'MSDP, Multicast Source Discovery Protocol' },
  {
    value: 641,
    name: 'SupportSoft Nexus Remote Command (control/listening)',
  },
  { value: 646, name: 'Label Distribution Protocol (LDP)' },
  { value: 647, name: 'DHCP Failover protocol' },
  { value: 648, name: 'RRP (Registry Registrar Protocol)' },
  { value: 651, name: 'IEEE-MMS' },
  { value: 653, name: 'SupportSoft Nexus Remote Command (data)' },
  { value: 654, name: 'Media Management System (MMS) Media Management Protocol (MMP)' },
  { value: 657, name: 'IBM RMC (Remote monitoring and Control)' },
  { value: 660, name: 'Mac OS X Server administration' },
  { value: 666, name: 'airserv-ng' },
  { value: 666, name: 'Doom' },
  { value: 674, name: 'ACAP (Application Configuration Access Protocol)' },
  { value: 688, name: 'REALM-RUSD (ApplianceWare Server Appliance Management Protocol)' },
  { value: 691, name: 'MS Exchange Routing' },
  { value: 694, name: 'Linux-HA High availability Heartbeat' },
  { value: 695, name: 'IEEE-MMS-SSL (IEEE Media Management System over SSL)[28]' },
  { value: 698, name: 'OLSR (Optimized Link State Routing)' },
  { value: 700, name: 'EPP (Extensible Provisioning Protocol)' },
  { value: 701, name: 'LMP (Link Management Protocol)' },
  {
    value: 702,
    name: 'IRIS over BEEP (Blocks Extensible Exchange Protocol)',
  },
  { value: 706, name: 'Secure Internet Live Conferencing (SILC)' },
  { value: 711, name: 'Cisco Tag Distribution Protocol' },
  { value: 712, name: 'Topology Broadcast based on Reverse-Path Forwarding routing protocol (TBRPF)' },
  { value: 749, name: 'Kerberos (protocol) administration' },
  { value: 750, name: 'kerberos-iv, Kerberos version IV' },
  { value: 751, name: 'kerberos_master, Kerberos authentication' },
  { value: 752, name: 'passwd_server, Kerberos Password (kpasswd) server' },
  { value: 753, name: 'Reverse Routing Header (rrh)' },
  { value: 753, name: 'Reverse Routing Header (rrh)[37]' },
  { value: 753, name: 'userreg_server, Kerberos userreg server' },
  { value: 754, name: 'krb5_prop, Kerberos v5 slave propagation' },
  { value: 754, name: 'tell send' },
  // { value: 754, name: 'tell send' },
  { value: 760, name: 'krbupdate, Kerberos registration' },
  { value: 782, name: 'Conserver serial-console management server' },
  { value: 783, name: 'SpamAssassin spamd daemon' },
  { value: 800, name: 'mdbe daemon' },
  { value: 808, name: 'Microsoft Net.TCP Port Sharing Service' },
  { value: 829, name: 'Certificate Management Protocol[38]' },
  { value: 843, name: 'Adobe Flash' },
  { value: 847, name: 'DHCP Failover protocol' },
  { value: 848, name: 'Group Domain Of Interpretation (GDOI) protocol' },
  { value: 860, name: 'iSCSI (RFC 3720)' },
  { value: 861, name: 'OWAMP control' },
  { value: 862, name: 'TWAMP control' },
  { value: 873, name: 'rsync file synchronization protocol' },
  { value: 888, name: 'cddbp, CD DataBase protocol (CDDBP)' },
  { value: 897, name: 'Brocade SMI-S RPC' },
  { value: 898, name: 'Brocade SMI-S RPC SSL' },
  { value: 901, name: 'Samba Web Administration Tool (SWAT)' },
  { value: 901, name: 'VMware Virtual Infrastructure Client ' },
  { value: 902, name: 'ideafarm-door' },
  { value: 902, name: 'VMware Server Console' },
  { value: 903, name: 'VMware Remote Console' },
  { value: 904, name: 'VMware Server Alternate' },
  { value: 911, name: 'Network Console on Acid (NCA)' },
  { value: 944, name: 'NetworkFile System (protocol) Service ' },
  { value: 953, name: 'Domain Name System (DNS) RNDC Service' },
  { value: 973, name: 'Network File System (protocol) over IPv6 Service' },
  { value: 981, name: 'SofaWare Technologies Remote HTTPS managemen' },
  { value: 987, name: 'Microsoft Corporation Microsoft Windows SBS SharePoint' },
  { value: 989, name: 'FTPS Protocol (data): FTP over TLS/SSL' },
  { value: 990, name: 'FTPS Protocol (control): FTP over TLS/SSL' },
  { value: 991, name: 'NAS (Netnews Administration System)' },
  { value: 992, name: 'TELNET protocol over TLS/SSL' },
  { value: 993, name: 'IMAPS (Internet Message Access Protocol over TLS/SSL)' },
  { value: 994, name: 'IRCS (Internet Relay Chat over TLS/SSL)' },
  { value: 995, name: 'POP3S (Post Office Protocol 3 over TLS/SSL)' },
  { value: 999, name: 'ScimoreDB Database System' },
  { value: 1002, name: 'Opsware agent (aka cogbot)' },
  { value: 1010, name: 'ThinLinc Web Administration' },
];
